import { useEffect } from 'react';
import './use-rebouncer.css';

const FRST = 'scaleOut';
const SCND = '_scaleOut';

export function useReBouncer(elementId: string) {
  useEffect(() => {
    const elem = document.getElementById(elementId);
    return () => {
      elem?.classList.remove(FRST);
      elem?.classList.remove(SCND);
    };
  }, [elementId]);

  function reBounce() {
    const elem = document.getElementById(elementId);
    if (!elem) {
      return;
    }
    if (elem?.classList.contains(FRST)) {
      elem.classList.remove(FRST);
      elem.classList.add(SCND);
    } else {
      elem.classList.add(FRST);
      elem.classList.remove(SCND);
    }
  }

  return { reBounce };
}
